import React, { useState, useEffect, useRef } from "react";
import { stateWiseCountApi, getDealerAgentMapsInfoByData, getStateWiseMapInfoData, getAllstateListDistrictByType } from "../maketingComponents/actioncreator";
import { firstDateOfMonth, formatDate, lastDateOfMonth, monthStartDate, reverseFormat, subtractOneDay, todayDate } from "../maketingComponents/utils/utils";
import ReactApexChart from "react-apexcharts";
import Skeleton from "react-loading-skeleton";
import CustomMapComponent from "./CustomMapsComponent";

const AgestatusData = ({ admin }) => {
    const [nameOpportunity, setNameopportunity] = useState([])
    const [dataOpportunity, setDataopportunity] = useState([])
    const [dealerData, setdealerData] = useState([])
    const [showMaps, setshowMaps] = useState(false)
    const [mapType, setMapType] = useState("all")
    const [stateList, setStateList] = useState([])
    const [districtList, setDistrcitList] = useState([])

    const [payload, setPayload] = useState({
        fromDate: monthStartDate(),
        toDate: todayDate(),
        minDate: monthStartDate(),
        state: "", city: ""
    });
    const [rejectReasonData, setRejectReasonData] = useState([]);
    const [graphData, setGraphData] = useState([]);
    const [optionsData, setOptionsData] = useState('');
    const [today, setToday] = useState(todayDate())

    useEffect(() => {
        getdataapi();
        getStateWiseMapInfoDataFn()
        getAllstateListDistrictByTypeFn()
    }, []);

    const getAllstateListDistrictByTypeFn = () => {
        getAllstateListDistrictByType("AMU Agent", callback => {
            setStateList(callback?.data || [])
        })
    }




    const getDealerAgentMapsInfoByDataFn = () => {
        getDealerAgentMapsInfoByData(payload?.fromDate, payload?.toDate, "", "", "", "", callBack => {
            setdealerData(callBack?.data || [])
            setshowMaps(callBack?.data?.length > 0 ? true : false)
            setMapType("dealerwise")
        })
    }

    const getStateWiseMapInfoDataFn = () => {
        getStateWiseMapInfoData(payload?.fromDate, payload?.toDate, callBack => {
            setdealerData(callBack?.data || [])
            setshowMaps(callBack?.data?.length > 0 ? true : false)
            setMapType("all")
        })
    }

    const getdataapi = () => {

        stateWiseCountApi(
            payload,
            (callBack) => {

                setRejectReasonData(callBack);
                makegraphDataOpportunity(callBack)


            },
            (error) => {
                console.log(error);
            }
        );
    };

    const applyFilter = () => {
        setTimeout(()=>{
            getdataapi()
            if ((payload?.state == "") && (payload?.city == "")) {
                getStateWiseMapInfoDataFn()
            } else {
                getDealerAgentMapsInfoByDataFn()
            }
        },20)
    }

    const clearFilter = ()=>{
         getdataapi()
         getStateWiseMapInfoDataFn()
         setPayload({
              fromDate: monthStartDate(),
        toDate: todayDate(),
        minDate: monthStartDate(),
        state:"",city:''
         })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newPayload = {
            ...payload,
            [name]: formatDate(value),
        };
        if (name === "fromDate") {
            newPayload.toDate = payload.toDate;
        } else {
            newPayload.fromDate = payload.fromDate;
        }
        setPayload(newPayload);
    };

    const handleChangeNew = (e) => {
        const { name, value } = e.target;
        const newPayload = {
            ...payload,
            [name]: value,
        };
        setPayload(newPayload);
        if (type == "state") {
            const ar = stateList?.filter((el) => el?.state == e.target.value)
            setDistrcitList(ar?.[0]?.cities || [])
        }
    }

    const prepareChartData = (data) => {

        const categories = Object.values(data.xaxis.categories);
        const seriesData = Object.values(data.xaxis.categories);
        const options = {
            series: [{
                data: seriesData
            }],
            chart: {
                type: 'bar',
                height: 350
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: categories
            }
        };
        setOptionsData(options);
        console.log(options)
    };


    const makegraphDataOpportunity = (To) => {
        let name = [];
        let data = [];

        for (const item of To) {
            const { count, state, } = item;

            name.push(state);

            data.push(count);
        }

        setNameopportunity(name);
        setDataopportunity(data);

        console.log(Object.values(nameOpportunity))

    }
    var options = {
        series: [{
            data: Object.values(dataOpportunity),

        }],
        chart: {
            type: 'bar',
            height: 350
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '50%',
                barWidth: '90%',
                borderRadius: '0 10 30 90'

            }
        },
        colors: ['#7978E9'],
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: nameOpportunity,
        },


    };

    return (
        <div>
            <div className="col-sm-12 col-xs-12 shadow" style={{ marginBottom: '20px', border: '1px solid rgba(0, 0, 0, 0.25)', borderRadius: '10px', minHeight: '600px' }}>
                <div className="bg-white p-4 " style={{ padding: '15px' }}>
                    <h5 style={{ color: '#1d3557', fontWeight: '700' }}> <strong style={{ paddingTop: '10px' }}>Form Status Stats</strong></h5>
                    <div className="row">
                        <div className="col-sm-2 col-xs-12" style={{ marginTop: '4px' }}>
                            From
                            <input
                                type="date"
                                id="startDate"
                                placeholder="DD/MM/YY"
                                name="fromDate"
                                value={reverseFormat(payload.fromDate)}
                                onChange={handleChange}
                                className=" form-control"
                                style={{
                                    border: "1px solid gray",
                                    borderRadius: "6px",
                                    padding: "10px",
                                }}
                            />
                        </div>

                        <div className="col-sm-2 col-xs-12">
                            <div className="filterHeaders" style={{ marginTop: "4px" }}>
                                to
                            </div>

                            <input
                                type="date"
                                id="endDate"
                                name="toDate"
                                max={reverseFormat(subtractOneDay(today))}
                                value={reverseFormat(subtractOneDay(payload.toDate))}
                                onChange={handleChange}
                                placeholder="DD/MM/YY"
                                className=" form-control"
                                style={{
                                    border: "1px solid gray",
                                    borderRadius: "6px",
                                    padding: "10px",
                                }}
                            />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <div className="filterHeaders" style={{ marginTop: "4px" }}>
                                State
                            </div>
                            <select
                                className=" form-control"
                                value={payload?.state}
                                name="state"
                                onChange={handleChangeNew}
                            >
                                <option>Select State</option>
                                {
                                    stateList?.length > 0 ? stateList?.map((val, id) => {
                                        return (
                                            <option value={val?.state}>{val?.state}</option>
                                        )
                                    })
                                        : ""}

                            </select>

                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <div className="filterHeaders" style={{ marginTop: "4px" }}>
                                State
                            </div>
                            <select
                                className=" form-control"
                                value={payload?.state}
                                name="state"
                                onChange={handleChangeNew}
                            >
                                <option>Select City</option>
                                {
                                    districtList?.length > 0 ? districtList?.map((val) => {
                                        return (
                                            <option value={val}>{val}</option>
                                        )
                                    })
                                        : ""
                                }

                            </select>

                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <button
                                className="btn btn-primary mt-4 "
                                style={{
                                    color: "#064254",
                                    borderColor: "#064254",
                                    backgroundColor: "white",
                                    marginTop: "23px",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    marginRight:'10px'
                                }}
                                onClick={applyFilter}
                            >
                                Apply Filter
                            </button>
                            <button
                                className="btn btn-primary mt-4 "
                                style={{
                                    color: "#064254",
                                    borderColor: "#064254",
                                    backgroundColor: "white",
                                    marginTop: "23px",
                                    padding: "10px",
                                    borderRadius: "5px",
                                }}
                                onClick={clearFilter}
                            >
                                Clear Filter
                            </button>
                        </div>
                    </div>


                    <hr />
                    <div className="row">
                        <div className="col-sm-6 col-xs-12 other-table">
                            <div className='marketing-table' style={{ fontSize: '12px', width: '90%', marginRight: 'auto' }} >
                                <table>
                                    <thead style={{ background: 'rgba(0, 108, 103, 0.2)', color: '#000', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                        <tr className="thead-class">
                                            <th style={{ width: '20%', }} className="">
                                                <b>State</b>
                                            </th>
                                            <th style={{ width: '20%', }} className="">
                                                <b>Month</b>
                                            </th>
                                            <th style={{ width: '20%' }} className="">
                                                <b>Counts</b>
                                            </th>
                                            <th style={{ width: '20%' }} className="">
                                                <b>Percentage</b>
                                            </th>

                                        </tr>
                                    </thead>
                                    {rejectReasonData.length > 0 ?
                                        <tbody style={{ height: '650px', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                            {rejectReasonData.map((data1, i) => {

                                                return (
                                                    <tr style={{ borderBottom: "none", fontWeight: '400' }} key={i}>
                                                        <td style={{ width: '20%' }} scope="col">
                                                            {data1.state}
                                                        </td>
                                                        <td style={{ width: '20%' }} scope="col">
                                                            {data1.month}
                                                        </td>
                                                        <td style={{ width: '20%' }} scope="col">
                                                            {data1.count}
                                                        </td>
                                                        <td style={{ width: '20%' }} scope="col">
                                                            {data1.percentage}
                                                        </td>

                                                    </tr>
                                                )

                                            })}
                                            <tr className="thead-class" style={{ fontWeight: 'bold', background: '#B9D8F973' }}>
                                                <td style={{ borderBottomLeftRadius: '10px', width: '50%' }}><b>Total</b></td>
                                                <td colSpan={2} style={{ width: '50%', borderBottomRightRadius: '10px' }}>
                                                    <b>{rejectReasonData[0].total}</b>
                                                </td>
                                                {/* <td style={{ borderBottomRightRadius: '10px' }}></td> */}
                                            </tr>

                                        </tbody>
                                        :
                                        <tbody style={{ height: '650px', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>

                                            </tr>

                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>

                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12 " id='chart'>
                            <div style={{ border: '1px solid rgba(0, 0, 0, 0.15)', padding: '10px', borderRadius: '10px', marginTop: '21px' }}>
                                <h5><b>Form Status Stats</b></h5>
                                <ReactApexChart options={options} series={options.series} type="bar" height={630} width={'100%'} />
                            </div>
                        </div>
                        {
                            showMaps ?
                                <div className=" col-xs-12 " id='chart'>
                                    <div style={{ border: '1px solid rgba(0, 0, 0, 0.15)', padding: '10px', borderRadius: '10px', marginTop: '21px' }}>
                                        <CustomMapComponent dealerData={dealerData} TextType={"Dealers"} totalHeight={"373px"} showTotalDealer={false} mapType={mapType} />
                                    </div>
                                     <div style={{ marginTop: '15px',display:'flex',gap:'15px',justifyContent:'center',alignItems:'center' }}>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>Conversion Rate:</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#008000', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 80%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#66CC66', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{'>= 60%'}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FFFF66', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 40%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FFA500', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 20%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FF0000', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`< 20%`}</h5>
                                    </div>
                                </div>
                                </div>
                                : ""}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgestatusData;


